import { memo, useCallback, useContext } from 'react';
import I18n from 'I18n';
import { SPEED_OPTIONS } from '../../../constants/MediaPlayerSettings';
import { MediaPlaybackRateContext } from '../../context/MediaPlaybackRateContext';
import { ActionsMenu } from 'foundations-components/components/ActionsMenu';
import { jsx as _jsx } from "react/jsx-runtime";
const SpeedSelect = /*#__PURE__*/memo(props => {
  const {
    setPlaybackRate,
    playbackRate
  } = useContext(MediaPlaybackRateContext);
  const {
    onSpeedSelectCallback
  } = props;
  const handleSetSpeed = useCallback(speed => {
    setPlaybackRate(speed);
    if (onSpeedSelectCallback) {
      onSpeedSelectCallback(speed);
    }
  }, [onSpeedSelectCallback, setPlaybackRate]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ActionsMenu, {
      "aria-label": I18n.text('recordingReviewComponents.media.mediaPlayer.ariaLabels.playbackSpeed'),
      use: 'link-on-bright',
      onActionClick: ({
        value
      }) => handleSetSpeed(+value),
      actions: SPEED_OPTIONS.map(option => ({
        text: I18n.text('recordingReviewComponents.media.mediaPlayer.speed', {
          speed: option
        }),
        value: option
      })),
      "data-test-id": "mediaPlayerControls-speedDropdown",
      placement: "bottom-start",
      referenceText: I18n.text('recordingReviewComponents.media.mediaPlayer.speed', {
        speed: playbackRate
      }),
      menuInlineSize: 200
    })
  });
});
export default SpeedSelect;